<template>
	<tr>
		<th>住所<span>必須</span></th>
		<td>
			<p class="address_num"><input type="number" v-model="zipc3" autocomplete="off" required> - <input type="number" v-model="zipc4" autocomplete="off" required><input type="button" value="住所を検索" v-on:click="fillAdd"></p>
			<p class="custom_select">
				<select name="pref" v-model="pref">
					<option value="" selected class="first" autocomplete="address-level1">都道府県</option>
					<option value="北海道">北海道</option>
					<option value="青森県">青森県</option>
					<option value="岩手県">岩手県</option>
					<option value="宮城県">宮城県</option>
					<option value="秋田県">秋田県</option>
					<option value="山形県">山形県</option>
					<option value="福島県">福島県</option>
					<option value="茨城県">茨城県</option>
					<option value="栃木県">栃木県</option>
					<option value="群馬県">群馬県</option>
					<option value="埼玉県">埼玉県</option>
					<option value="千葉県">千葉県</option>
					<option value="東京都">東京都</option>
					<option value="神奈川県">神奈川県</option>
					<option value="新潟県">新潟県</option>
					<option value="富山県">富山県</option>
					<option value="石川県">石川県</option>
					<option value="福井県">福井県</option>
					<option value="山梨県">山梨県</option>
					<option value="長野県">長野県</option>
					<option value="岐阜県">岐阜県</option>
					<option value="静岡県">静岡県</option>
					<option value="愛知県">愛知県</option>
					<option value="三重県">三重県</option>
					<option value="滋賀県">滋賀県</option>
					<option value="京都府">京都府</option>
					<option value="大阪府">大阪府</option>
					<option value="兵庫県">兵庫県</option>
					<option value="奈良県">奈良県</option>
					<option value="和歌山県">和歌山県</option>
					<option value="鳥取県">鳥取県</option>
					<option value="島根県">島根県</option>
					<option value="岡山県">岡山県</option>
					<option value="広島県">広島県</option>
					<option value="山口県">山口県</option>
					<option value="徳島県">徳島県</option>
					<option value="香川県">香川県</option>
					<option value="愛媛県">愛媛県</option>
					<option value="高知県">高知県</option>
					<option value="福岡県">福岡県</option>
					<option value="佐賀県">佐賀県</option>
					<option value="長崎県">長崎県</option>
					<option value="熊本県">熊本県</option>
					<option value="大分県">大分県</option>
					<option value="宮崎県">宮崎県</option>
					<option value="鹿児島県">鹿児島県</option>
					<option value="沖縄県">沖縄県</option>
				</select>
			</p>
			<p><input type="text" placeholder="市区町村" v-model="addr" v-on:change="update" autocomplete="address-level2" required></p>
			<p><input type="text" placeholder="番地以降" v-model="block" v-on:change="update" autocomplete="address-line1" required></p>
		</td>
	</tr>
</template>

<script>
import Vue from 'vue'
import { Core as YubinBangoCore } from 'yubinbango-core';

export default {
  name: 'Address',
  props: [
    'address',
    'zipcode'
  ],
  data () {
    return {
      pref: '',
      addr: '',
      block: '',
      zipc3: '',
      zipc4: '',
    }
  },
  watch: {
    zipcode(v, o) {
      this.zipc3 = this.zipcode.substr(0,3)
      this.zipc4 = this.zipcode.substr(3)
    },
    address(v, o) { 
      new YubinBangoCore(this.zipc3 + this.zipc4, addr => { 
        this.pref = addr.region 
        this.addr = addr.locality + addr.street + addr.extended
      })
    },
    addr(v,o) {
      if (this.addr != '') this.block = this.address.replace(this.pref, '').replace(this.addr, '')
    }
  },
  methods: {
    fillAdd () {
      new YubinBangoCore(this.zipc3 + this.zipc4, addr => { 
        this.pref = addr.region 
        this.addr = addr.locality + addr.street + addr.extended
      })
      this.update()
    },
    update () {
      this.$emit('updateAddress', this.pref + this.addr + this.block, this.zipc3 + this.zipc4)
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Address.vue